import axios from './http'

// 用户登录
export const PostLogin = params => {
    return axios.post("/login", params).then(res => res.data)
};

// 获取验证码
export const getCodeImg = () => {
    return axios.get('/captchaImage').then(res => res.data)
}
